<template>
    <div class="hold" v-if="isMounted" v-can="'settings_hold.access'">
        <ds-table
            :data="holds"
            :heads="heads"
            :paginate="false"
            :max-items="holds.length"
            spacer
        >
            <template v-slot:start="{start}">
                <div class="flex items-center">
                    <vs-icon color="primary" class="mr-2" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"/>
                    <p class="font-medium">{{ start.start }}</p>
                </div>
            </template>

            <template v-slot:end="{end}">
                <div class="flex items-center">
                    <vs-icon color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')" class="mr-2"/>
                    <p class="font-medium">{{ end.end }}</p>
                </div>
            </template>

            <template v-slot:status="{status}">
                <vs-switch
                    v-can="'settings_hold.destroy'"
                    color="success"
                    @click="changeStatus($event, status)"
                    icon-pack="feather"
                    :checked="Boolean(status.is_active)"
                    :disabled="!status.id" vs-icon-off="icon-x"
                    vs-icon-on="icon-check"
                />
                <vs-switch
                    v-can:show="'settings_hold.destroy'"
                    disabled color="success"
                    icon-pack="feather"
                    :checked="Boolean(status.is_active)"
                    vs-icon-off="icon-x"
                    vs-icon-on="icon-check"
                />
            </template>

            <template v-slot:actions="{actions}">
                <vs-button
                    v-can="'settings_hold.update'"
                    @click.stop.prevent="editHold(actions)"
                    v-tooltip="$t('modals.Edit_hold')"
                    class="mr-3"
                    radius
                    color="primary"
                    type="flat"
                    v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"
                />
                <vs-button
                    v-can:show="'settings_hold.update'"
                    disabled
                    class="mr-3"
                    radius
                    color="primary"
                    type="flat"
                    v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"
                />
            </template>
        </ds-table>
    </div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex'
import EventBus from '@/store/eventBus'
import ErrorHandler from '@/utils/errorHandler'

export default {
    data() {
        return {
            loadingEl: null,
            isMounted: false,
            currentHold: null,
            heads: [
                {name: 'global.Geo', key: 'geo_name', sortKey: 'geo_name', value: 'geo_name', display: true},
                {name: 'settings.Start', key: 'start', value: 'start', display: true},
                {name: 'settings.End', key: 'end', value: 'end', display: true},
                {name: 'settings.New', key: 'asc', sortKey: 'asc', value: 'asc', display: true},
                {name: 'settings.Old', key: 'desc', sortKey: 'desc', value: 'desc', display: true},
                {name: 'settings.Timing', key: 'timing', sortKey: 'timing', value: 'timing', display: true},
                {name: 'global.Status', key: 'status', sortKey: 'is_active', value: 'status', display: true},
                {name: 'global.Actions', key: 'actions', value: 'actions', display: true},
            ]
        }
    },

    computed: {
        ...mapGetters(['geo', 'holds'])
    },

    methods: {
        ...mapActions(['GET_HOLDS', 'GET_GEOS', 'UPDATE_STATUS_HOLD']),

        changeStatus(e, data) {
            e.preventDefault()
            this.currentHold = data.id

            this.loadingEl = e.target.parentNode
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: data.is_active ? this.$t('confirm.deactivateHold') : this.$t('confirm.activateHold'),
                accept: this.sendStatus,
                acceptText: data.is_active ? this.$t('buttons.Deactivate') : this.$t('buttons.Activate'),
                cancelText: this.$t('global.Cancel')
            })
        },

        async sendStatus() {
            this.$vs.loading({
                background: 'rgba(255,255,255,0.75)',
                color: 'primary',
                container: this.loadingEl,
                scale: +'0.45'
            })

            await this.UPDATE_STATUS_HOLD({ id: this.currentHold})

            this.$vs.loading.close(this.loadingEl)
        },

        editHold(data) {
            EventBus.$emit('emitPopupEvent', {
                type: 'editHold',
                name: this.$t('modals.Edit_hold'),
                ids: {...data}
            })
        }
    },

    async mounted() {
        try {
            await this.GET_GEOS()
            await this.GET_HOLDS()
            this.isMounted = true
        } catch (e) {
            new ErrorHandler(e).send
        }
    }
}
</script>
